module.exports = __webpack_public_path__ + "static/media/testobalance1.06a79c0d.pdf";